import { useState, useEffect, Fragment } from 'react';
import { UploadImageInputProps } from './types';
import './styles.scss';
import User from 'assets/User';

const UploadImageInput = (props: UploadImageInputProps) => {
    const [imageURL, setImageURL] = useState("");
    useEffect(() => {
        props.value!.trim().length > 0 && setImageURL(props.value!);
    }, [])
    const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { files } = event.target;
        if (files && files.length > 0) setImageURL(URL.createObjectURL(files[0]));
        props.onChange && props.onChange(event);
    }
    const onDelete = () => {
        setImageURL("");
        props.onDelete && props.onDelete();
    }
    return (
        <div className={`d-flex align-items-center __UploadImageInput position-relative ${props.className}`}>
            {imageURL.trim().length > 0 ? (
                <Fragment>
                    <img src={imageURL} alt="" />
                    <button type='button' onClick={onDelete}>Delete</button>
                </Fragment>
            ) : (
                    <Fragment>
                        <User className='user-default-image position-absolute' />
                        <input type="file" id='profile-image' onChange={onChange} accept='image/*' name={props.name} />
                        <label htmlFor="profile-image" className='font-weight-bold d-flex align-items-center justify-content-center text-white'>Upload</label>
                    </Fragment>
                )}
        </div>
    )
}

export default UploadImageInput;